<template>
	<v-tour :class="(userOnboardingPerPageName !== 'dashboard') ? 'vue-onboarding' : 'vue-onboarding-per-page'"
	        name="onboarding" v-bind="$props" :steps="steps" :callbacks="callbacks" :options="dataOptions">
		<template slot-scope="tour">
			<transition name="fade">
				<v-step
					v-bind="{ ...tour }"
					v-if="tour.steps[tour.currentStep]"
					:key="tour.currentStep"
					:step="{ offset: offsetStep, ...tour.steps[tour.currentStep] }"
					:previous-step="tour.previousStep"
					:next-step="tour.nextStep"
					:stop="tour.stop"
					:skip="tour.skip"
					:is-first="tour.isFirst"
					:is-last="tour.isLast"
					:labels="tour.labels">
					<!-- Header -->
					<template v-if="tour.steps[tour.currentStep].header ? true : false" slot="header">
						<vue-onboarding-header
							v-if="userOnboardingPerPageName !== 'dashboard'"
							:title="tour.steps[tour.currentStep].header.title"
							:closeable="(typeof tour.steps[tour.currentStep].header.closeable === 'function') ? tour.steps[tour.currentStep].header.closeable() : tour.steps[tour.currentStep].header.closeable"
							@close="onClose"
							confirmText="Bạn muốn tạm ngưng hướng dẫn cho người mới?"
							:confirmable="tour.steps[tour.currentStep].header.confirmable"
							:confirmCallback="tour.steps[tour.currentStep].header.confirmCallback || null">
							<template v-slot:progress>
								<vue-onboarding-progress
									:currentStep="$tours.onboarding.currentStep + 1"
									:maxSteps="steps.length || 0"></vue-onboarding-progress>
							</template>
						</vue-onboarding-header>

						<vue-onboarding-header-per-page v-else
						                                :title="tour.steps[tour.currentStep].header.title"
						                                :stepText="tour.steps[tour.currentStep].header.stepText"
						></vue-onboarding-header-per-page>
					</template>
					<!-- Content -->
					<template slot="content">
						<vue-onboarding-content v-if="userOnboardingPerPageName !== 'dashboard'"
						                        :step="tour.steps[tour.currentStep]"></vue-onboarding-content>

						<vue-onboarding-content-per-page v-else
						                                 :step="tour.steps[tour.currentStep]"></vue-onboarding-content-per-page>
					</template>
					<!-- Actions -->
					<template slot="actions">
						<vue-onboarding-actions
							v-if="
                                tour.steps[tour.currentStep].hasOwnProperty('actions')
                                    ? actions(tour.steps[tour.currentStep].actions).length !== 0
                                    : false
                            "
							:actions="actions(tour.steps[tour.currentStep].actions)"
							:userOnboardingPerPageName="userOnboardingPerPageName"
							@next="onNextAction"
							@previous="onPreviousAction"
							@onExitPerPage="onExitPerPage"
							@onNextPerPage="onNextPerPage"
							@onFinishPerPage="onFinishPerPage"
						></vue-onboarding-actions>
						<div v-else></div>
					</template>
				</v-step>
			</transition>
		</template>
	</v-tour>
</template>

<script>
import VueOnboardingHeader from './VueOnboardingHeader.vue';
import VueOnboardingContent from './VueOnboardingContent.vue';
import VueOnboardingProgress from './VueOnboardingProgress.vue';
import VueOnboardingActions from './VueOnboardingActions.vue';
import onboardingService from '../../core/services/onboardingService';
import 'vue-tour/dist/vue-tour.css';

import VueOnboardingHeaderPerPage from './VueOnboardingHeaderPerPage.vue';
import VueOnboardingContentPerPage from './VueOnboardingContentPerPage.vue';
import userOnboardingPerPage from '../../core/services/userOnboardingPerPage';
import {mapState} from 'vuex';

export default {
	name: 'vue-onboarding',

	components: {
		VueOnboardingHeader,
		VueOnboardingContent,
		VueOnboardingProgress,
		VueOnboardingActions,
		VueOnboardingHeaderPerPage,
		VueOnboardingContentPerPage,
	},

	props: {
		options: {
			type: Object,
			default: () => ({}),
		},

		/**
		 * Event said finished onboarding
		 * @emit('finish)
		 */
	},

	data() {
		return {
			dataOptions: {
				highlight: true,
				enabledButtons: {
					buttonSkip: false,
					buttonPrevious: false,
					buttonNext: false,
					buttonStop: false,
				},
				useKeyboardNavigation: false,
				enabledNavigationKeys: {
					escape: false,
					arrowRight: false,
					arrowLeft: false,
				},
				...this.options,
			},

			callbacks: {
				onStart: this.onStart,
				onPreviousStep: this.onPreviousStep,
				onNextStep: this.onNextStep,
				onSkip: this.onSkip,
				onFinish: this.onFinish,
				onStop: this.onStop,
			},
		};
	},

	computed: {
		steps() {
			return this.$store.state.vueOnboarding.steps;
		},

		offsetStep() {
			return (window.innerHeight / 2) * -1;
		},

		...mapState({
			isUserOnboardingPerPage: (state) => state.vueOnboarding.onboardingPerPage.isOnboardingPerPage,
			userOnboardingPerPageName: (state) => state.vueOnboarding.onboardingPerPage.pageName,
		})
	},

	watch: {},

	methods: {
		actions(actions = {}) {
			const acts = [];

			for (const key in actions) {
				if (actions.hasOwnProperty(key) && actions[key]) {
					acts.push(key);
				}
			}

			return acts;
		},

		onStart(currentStep) {
		},

		onPreviousStep(currentStep) {
		},

		onNextStep(currentStep) {
		},

		onSkip(currentStep) {
		},

		onFinish(currentStep) {
		},

		onStop(currentStep) {
		},

		onNextAction() {
			onboardingService.next();
		},

		onPreviousAction() {
			onboardingService.prev();
		},

		onExitPerPage() {
			if (window.confirm('Bạn muốn tạm ngưng hướng dẫn cho người mới?')) {
				this.$root.$emit("onCloseOnboardingDashboard");
				this.syncUserOnboardingToAirTable();
			}
		},
		onNextPerPage() {
			onboardingService.next();
		},
		onFinishPerPage() {
			let isFullFlow = true;
			this.$root.$emit("onCloseOnboardingDashboard");
			this.syncUserOnboardingToAirTable(isFullFlow);
		},
		onClose() {
			this.$root.$emit("onCloseOnboardingDashboard");
			this.syncUserOnboardingToAirTable();
		},
		syncUserOnboardingToAirTable(isFullFlow = false) {
			let currentStep = onboardingService.currentStep();
			let pageName = this.userOnboardingPerPageName;
			let typeActionStop;

			if (pageName === 'dashboard') {
				typeActionStop = userOnboardingPerPage.perPage.dashboard.obd2_stop_at;
			}

			if (pageName === 'campaign') {
				typeActionStop = userOnboardingPerPage.perPage.campaign.obd1_stop_at;
			}

			let params = {
				page_name: pageName,
				type_action: typeActionStop,
				is_full_flow: isFullFlow
			}

			params[typeActionStop] = currentStep;

			userOnboardingPerPage.syncUserOnboardingToAirTable(params);
			onboardingService.finish();
		}
	},

	mounted() {
	},
};
</script>

<style lang="scss">
$secondary: #e9ecef;
$black: #212529;
body {
	&.v-tour--active {
		overflow: hidden !important;
	}
}

.v-tour--active {

	&.v-tour--advertising-vh {
		height: 170vh;
	}

	.layout--main {
		.v-nav-menu {
			.vs-sidebar {
				// z-index: 0;
			}
		}
	}

	// .the-navbar-vertical {
	//     z-index: 102 !important;
	// }
	// &.the-navbar-vertical--low-z-index {
	//     .the-navbar-vertical {
	//         z-index: 99 !important;
	//     }
	// }

	@media screen and (min-width: 1280px) {
		overflow: hidden;
	}
}

.v-tour__target--highlighted {
	border-radius: 8px;
	box-shadow: 0 0 0 4px var(--vs-hex-white), 0 0 0 (9999999px) rgba($color: #000000, $alpha: 0.3) !important;
	pointer-events: auto;
	// Fix highlight input
	&.vs-input {
		padding: 0 !important;
	}

	z-index: 100000;
}

.v-tour__target--highlighted.carer-h-container {
	border-radius: 50px
}


.v-step__arrow--dark {
	&::before {
		background: unset;
	}
}

.vue-onboarding {
	.v-step {
		z-index: 100000;
		padding: 0;
		border-radius: 5px;
		min-width: 370px;
		background: var(--vs-hex-white);
		color: $black;

		&[x-out-of-boundaries] {
			visibility: hidden !important;
		}

		&[data-popper-placement^=top] {
			margin-bottom: 0.85rem !important;

			.v-step__arrow {
				&::before {
					background: white !important;
				}
			}
		}

		&[data-popper-placement^=left] {
			margin-right: 0.85rem !important;

			.v-step__arrow {
				&::before {
					background: white !important;
				}
			}
		}

		&[data-popper-placement^=bottom] {
			margin-top: 0.85rem !important;

			.v-step__arrow {
				&::before {
					background: #e9ecef !important;
				}
			}
		}

		&[data-popper-placement^=right] {
			margin-left: 0.85rem !important;

			.v-step__arrow {
				&::before {
					background: white !important;
				}
			}
		}

		&[data-popper-reference-hidden] {
			display: none;
		}
	}

	.v-step--sticky {
		visibility: hidden !important;
	}

	.v-step__arrow {
		border-color: #E9ECEF !important;
	}
}

.vue-onboarding-per-page {
	.v-step {
		z-index: 100001;
		padding: 0;
		border-radius: 5px;
		min-width: 370px;
		background: var(--vs-hex-white);
		color: $black;

		&[x-out-of-boundaries] {
			visibility: hidden !important;
		}

		&[data-popper-placement^=top] {
			margin-bottom: 0.85rem !important;

			.v-step__arrow {
				&::before {
					background: #da2d8a !important;
				}
			}
		}

		&[data-popper-placement^=left] {
			margin-right: 0.85rem !important;

			.v-step__arrow {
				&::before {
					background: #da2d8a !important;
				}
			}
		}

		&[data-popper-placement^=bottom] {
			margin-top: 0.85rem !important;

			.v-step__arrow {
				&::before {
					background: #da2d8a !important;
					border-top: 1px solid #F3F2F7 !important;
					border-left: 1px solid #F3F2F7 !important;
				}
			}
		}

		&[data-popper-placement^=right] {
			margin-left: 0.85rem !important;

			.v-step__arrow {
				&::before {
					background: #da2d8a !important;
				}
			}
		}

		&[data-popper-reference-hidden] {
			display: none;
		}
	}

	.v-step--sticky {
		visibility: hidden !important;
	}

	.v-step__arrow {
		border-color: #F3F2F7 !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/VueOnboarding/VueOnboarding.vue